(() => {
  'use strict';
  window.VertalineGiftRules = (config) => {
    const families = ['cervirest', 'lumbarest', 'sleeprest'];
    const validId = (id) => /^[1-9]\d*$/.test(String(id || ''));
    const familyForLine = (line) => {
      if (line.properties?._Vertaline_gift === '1') return null;
      const assigned = line.properties?._Vertaline_family;
      for (const family of families) if (config.familyProducts?.[family]?.some((id) => validId(id) && String(id) === String(line.product_id))) return family;
      const name = `${line.handle || ''} ${line.product_title || ''} ${line.title || ''}`.toLowerCase();
      for (const family of families) if (name.includes(family)) return family;
      return families.includes(assigned) ? assigned : null;
    };
    const giftsForDevice = (family, properties = {}) => {
      if (!config.autoGifts) return [];
      if (family === 'sleeprest' && properties._Vertaline_bundle === '1') {
        const gifts = [];
        const count = Math.min(50, Math.max(0, Number(properties._Vertaline_bundle_count) || 0));
        for (let i = 1; i <= count; i++) {
          const prefix = `_Vertaline_bundle_${i}_`;
          if (!properties[prefix + 'label']) continue;
          gifts.push({key: `sleeprest${i}`, family, slot: i, id: properties[prefix + 'id'] || null, available: properties[prefix + 'available'] !== 'false', label: properties[prefix + 'label'], image: properties[prefix + 'image'] || '', value: Number(properties[prefix + 'value']) || 0, quantity: Math.min(10, Math.max(1, Number(properties[prefix + 'qty']) || 1))});
        }
        return gifts;
      }
      return (config.gifts || []).filter((gift) => gift.family === family).map((gift) => ({...gift, quantity: gift.quantity || 1}));
    };
    const deviceProperties = (original = {}, family) => {
      const properties = {...original};
      Object.keys(properties).filter((key) => key.startsWith('Omaggio incluso ') || /^_Vertaline_gift_(image|value)_\d+$/.test(key)).forEach((key) => delete properties[key]);
      properties._Vertaline_device = '1';
      properties._Vertaline_family = family;
      giftsForDevice(family, original).forEach((gift) => {
        if (!validId(gift.id)) {
          properties['Omaggio incluso ' + gift.slot] = gift.label;
          if (gift.image) properties['_Vertaline_gift_image_' + gift.slot] = gift.image;
          if (gift.value) properties['_Vertaline_gift_value_' + gift.slot] = String(gift.value);
        }
      });
      return properties;
    };
    const desiredGifts = (cart) => {
      const desired = new Map();
      for (const line of cart.items) {
        const family = familyForLine(line);
        if (!family) continue;
        for (const gift of giftsForDevice(family, line.properties)) {
          if (!validId(gift.id)) continue;
          const id = String(gift.id), quantity = gift.quantity * line.quantity;
          const existing = desired.get(id);
          if (existing) existing.quantity += quantity;
          else desired.set(id, {...gift, quantity});
        }
      }
      return desired;
    };
    return {familyForLine, giftsForDevice, deviceProperties, desiredGifts, validId};
  };
})();
